import { Injectable } from "@angular/core";
import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { EligibilityService } from "src/app/shared/services/eligibility.service";
import { BehaviorSubject, Subject } from "rxjs";
import { filter, mergeMap, tap, map } from "rxjs/operators";
import { Configuration } from "src/app/shared/configuration.enum";
import { TISA_INTEREST_RATE_PLAN_SUFFIX } from "src/app/shared/constants";

const { TISA_URL } = Configuration;

@Injectable({
  providedIn: 'root'
})
export class TermsAndDisclosuresService {
  constructor(
    private _facadeService: FacadeService,
    private _eligibilityService: EligibilityService
  ) { }

  private _updateTisaUrl$ = new Subject<void>();
  updateTisaUrl$ = this._updateTisaUrl$.asObservable();

  private _canContinueGeneralDisclosures$ = new BehaviorSubject<boolean>(true);
  canContinueGeneralDisclosures$ = this._canContinueGeneralDisclosures$.asObservable();

  private termsDisclosuresCompletedSubject = new BehaviorSubject<boolean>(false);
  termsDisclosuresCompleted$ = this.termsDisclosuresCompletedSubject.asObservable();

  private _employeeSavingsTisaUrl$ = this._eligibilityService.customerEligibility$.pipe(
    // When customer eligibility is executed check if selected product is employee savings product
    filter(() => this._facadeService.getIsEmployeeSavingsProduct()),

    // General disclosures can't continue until we get the new application data
    tap(() => this._canContinueGeneralDisclosures$.next(false)),

    // After customer eligibility is executed the interest plan is saved to the application so we must
    // get the updated application
    mergeMap(() => this._facadeService.getApplicationLog(this._facadeService.getSessionId())),

    // General disclosures can now continue
    tap(() => this._canContinueGeneralDisclosures$.next(true)),

    // Continue only if all products have a valid interest plan code
    /*
    filter(application =>
      !application.products!.filter(product =>
        !product.interestPlanCode
      ).length
    ),
    */

    // Send interest plan code down the pipe
    // TODO - Refactor for multi product
    map(application => application.products![0].interestPlanCode),

    // Continue only if there is a valid interest plan code
    filter(interestPlanCode => !!interestPlanCode),

    // Update local application request with interest plan code
    tap(interestPlanCode => this._updateLocalApplicationRequestInterestPlanCode(interestPlanCode!)),

    // Build and send down the pipe the interest plan code associated configuration key
    map(interestPlanCode => `${TISA_URL}${TISA_INTEREST_RATE_PLAN_SUFFIX}${interestPlanCode}`),

    // Send the configuration value down the pipe
    map(newTISAUrlKey => this._facadeService.getStorageItem(newTISAUrlKey)),

    // Continue only if the interest plan TISA URL exists
    filter(interestPlanTISAUrl => !!interestPlanTISAUrl),

    // Set the associated interest plan TISA URL in configuration
    tap(interestPlanTISAUrl => this._facadeService.addStorageItem(TISA_URL, interestPlanTISAUrl)),

    // Let everyone know TISA Url has been updated
    tap(() => this._updateTisaUrl$.next())
  ).subscribe();

  private _updateLocalApplicationRequestInterestPlanCode(interestPlanCode: number): void {
    const applicationRequest = this._facadeService.getShoppingCartApplicationLogsRequest();
    // TODO - Refactor for multi product
    applicationRequest.products![0].interestPlanCode = interestPlanCode;
    this._facadeService.setShoppingCartApplicationLogsRequest(applicationRequest);
  }

  setTermsDisclosuresCompleted(value: boolean): void {
    this.termsDisclosuresCompletedSubject.next(value);
  }
}
